import Vue from "vue";
import App from "./App.vue";
import wb from "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBiSvl4GFmVNgRA-EdJuEaGNnh7If6JhKg",
  authDomain: "gospel-bdc.firebaseapp.com",
  databaseURL: "https://gospel-bdc-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gospel-bdc",
  storageBucket: "gospel-bdc.appspot.com",
  messagingSenderId: "36793175949",
  appId: "1:36793175949:web:35449cc99a1368a765b7c4",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

Vue.prototype.$workbox = wb;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
